<router-outlet></router-outlet>

<toaster-container [toasterconfig]="toasterConfig"></toaster-container>
